export const grayScale = {
  0: '#F8F9FA',
  1: '#F1F3F4',
  2: '#E9ECEE',
  3: '#DEE2E5',
  4: '#CDD3D8',
  5: '#ACB4BB',
  6: '#868D94',
  7: '#495056',
  8: '#343A3E',
  9: '#212528',
};

export const colors = {
  green: '#4fcc53',
  orange: '#f8a91c',
  red: '#e63740',
  yellowL: '#fcd03d',
  yellowM: '#f9a91b',
  yellowD: '#f78725',
};

export const fontWeights = {
  thin: 100,
  ultraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  heavy: 800,
  black: 900,
};



// WEBPACK FOOTER //
// ./src/app/ui/inline-styles/variables.ts